import { LocalDate } from "@flockcover/flock-svc-core-types"
import { BaseFleetEntry, FleetEntry } from "../../api/fleet"

import { resolveCoverPeriods } from "../add/utils/resolveCoverPeriods"

type Dates = {
  onCover?: LocalDate
  offCover?: LocalDate
}

const updateFleetEntryWithCoverDates = (entry: FleetEntry, { onCover, offCover }: Dates) => ({
  ...entry,
  onCoverDate: onCover ?? entry.onCoverDate,
  offCoverDate: offCover ?? entry.offCoverDate,
})

export const makeEditedFleetEntries = (
  entries: ReadonlyArray<FleetEntry>,
  idsToEdit: Set<string>,
  onCover?: LocalDate,
  offCover?: LocalDate
) =>
  resolveCoverPeriods(
    entries.map((entry) => {
      if (entry.id && !idsToEdit.has(entry.id)) return entry
      return updateFleetEntryWithCoverDates(entry, {
        onCover,
        offCover,
      })
    })
  )

export const makeErrors = (
  entries: ReadonlyArray<FleetEntry>,
  editIdSet: Set<string>,
  validateOnCover: (entry: BaseFleetEntry) => string | undefined,
  validateOffCover: (entry: BaseFleetEntry) => string | undefined,
  onCover?: LocalDate,
  offCover?: LocalDate
) => {
  const errors = entries
    .filter((entry) => entry.id && editIdSet.has(entry.id))
    .map((entry) => {
      const editedEntry = updateFleetEntryWithCoverDates(entry, { onCover, offCover })
      return {
        vrn: editedEntry.registrationNumber,
        message: validateOnCover(editedEntry) || validateOffCover(editedEntry),
      }
    })
    .filter((error) => !!error.message) as { vrn: string; message: string }[]

  return errors
}

export const removeEntriesAddedInError = (
  entries: ReadonlyArray<FleetEntry>,
  editIdSet: Set<string>,
  addedInError: boolean
) => {
  if (!addedInError) return entries
  const filtered = entries.filter(
    (entry) => entry.id && !(editIdSet.has(entry.id) && entry.onCoverDate === entry.offCoverDate)
  )
  return filtered
}
